import { useCallback, useEffect, useState } from "react";

import { SELECTED_AUDIO_INPUT_KEY } from "../../../../constants";
import useDevices from "../../hooks/useDevices/useDevices";

export default function useInputDeviceId() {
  const { audioInputDevices } = useDevices();
  const [inputDeviceId, _setInputDeviceId] = useState("default");

  const setInputDevice = useCallback((inputId: string) => {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, inputId);
    _setInputDeviceId(inputId);
  }, []);

  useEffect(() => {
    const selectedSinkId = window.localStorage.getItem(SELECTED_AUDIO_INPUT_KEY);
    const hasSelectedAudioOutputDevice = audioInputDevices.some(
      (device) => selectedSinkId && device.deviceId === selectedSinkId
    );

    if (hasSelectedAudioOutputDevice) {
      _setInputDeviceId(selectedSinkId!);
    }
  }, [audioInputDevices]);

  return [inputDeviceId, setInputDevice] as const;
}
